<template>
  <div class="validation-text">
    <p v-if="value.required === false">Il campo è obbligatorio</p>

    <p v-if="value.numeric === false">
      Il campo deve contenere solo caratteri numerici.
    </p>

    <p v-if="value.minLength === false">
      Il campo deve avere almeno
      {{ value.$params.minLength.min }} lettere.
    </p>

    <p v-if="value.maxLength === false">
      Il campo non può superare le
      {{ value.$params.maxLength.max }} lettere.
    </p>

    <p v-if="value.namePattern === false">
      Il campo deve contenere solamente caratteri dell'alfabeto
    </p>

    <p v-if="value.email === false">
      L'email inserita non è valida
    </p>

    <p v-if="value.phonePattern === false">
      Il numero di telefono inserito non è valido
    </p>

    <p v-if="value.fiscalCodePattern === false">
      Il codice fiscale inserito non è valido
    </p>

    <p v-if="value.cartaIdentitaPattern === false">
      Il numero documento che hai inserito non è valido per la carta d'identità
      cartacea, verifica di aver selezionato il tipo di documento corretto.
    </p>

    <p v-if="value.cartaIdentitaElettronicaPattern === false">
      Il numero documento che hai inserito non è valido per la carta d'identità
      elettronica, verifica di aver selezionato il tipo di documento corretto.
    </p>

    <p v-if="value.documentNumberPattern === false">
      Il numero documento che hai inserito non è valido, verifica di aver
      selezionato il tipo di documento corretto.
    </p>

    <p v-if="value.addressPattern === false">
      L'indirizzo non è valido, sono ammessi solamente caratteri alfanumerici
    </p>

    <p
      v-if="
        value.cityPattern === false ||
          value.houseNumberPattern === false ||
          value.fullAddressPattern === false
      "
    >
      Il valore inserito non è valido
    </p>

    <p v-if="serverErrors && serverErrors.length > 0">
      {{ serverErrors[0] }}
    </p>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ValidationText",
  props: {
    value: Object,
    serverErrors: Array
  }
};
</script>

<style scoped lang="less"></style>
